import { makeStyles } from '@material-ui/core';
import { Colors } from '../layout/theme-next';

const ARROW_SIZE = 6;

export default makeStyles({
  popper: {
    zIndex: 1500,
    pointerEvents: 'none',
  },
  popperInteractive: {
    pointerEvents: 'auto',
  },
  tooltip: {
    fontSize: 12,
    lineHeight: 1.4,
    background: Colors.textBlack,
    color: Colors.white,
    borderRadius: 4,
    padding: '6px 10px',
    maxWidth: 350,
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    fontFamily: 'Sora, sans-serif',
  },
  arrow: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    color: Colors.textBlack,
    '[x-placement^="top"] &': {
      borderWidth: `${ARROW_SIZE}px ${ARROW_SIZE}px 0`,
      borderColor: 'currentColor transparent transparent',
      bottom: -ARROW_SIZE,
    },
    '[x-placement^="bottom"] &': {
      borderWidth: `0 ${ARROW_SIZE}px ${ARROW_SIZE}px`,
      borderColor: 'transparent transparent currentColor',
      top: -ARROW_SIZE,
    },
    '[x-placement^="right"] &': {
      borderWidth: `${ARROW_SIZE}px ${ARROW_SIZE}px ${ARROW_SIZE}px 0`,
      borderColor: 'transparent currentColor transparent transparent',
      left: -ARROW_SIZE,
    },
    '[x-placement^="left"] &': {
      borderWidth: `${ARROW_SIZE}px 0 ${ARROW_SIZE}px ${ARROW_SIZE}px`,
      borderColor: 'transparent transparent transparent currentColor',
      right: -ARROW_SIZE,
    },
  },
}, { name: 'OverflowTooltip' });
